module.exports = __webpack_public_path__ + "static/media/health-essensial.c6b5e8bb.jpg";